export const prices = [2000, 3000, 5000];
